import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import { useMutation } from '@tanstack/react-query';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import logService from 'v2/services/log';

const AlumyWarning = () => {
  const [answeredWarning, setAnsweredWarning] = useState(localStorage.getItem('answeredAlumyWarning') === 'true');
  const logInfoMutation = useMutation((eventName: string) => logService.logEvent(eventName));
  const isBetaShowAlumyWarning = eduzzAccountsService.verifyUserHasBetaModule('show-alumy-warning');

  const handleCloseAlert = async () => {
    try {
      await logInfoMutation.mutateAsync('user_answered_alumy_warning');
      localStorage.setItem('answeredAlumyWarning', 'true');
    } finally {
      setAnsweredWarning(true);
    }
  };

  if (answeredWarning || !isBetaShowAlumyWarning) return null;

  return (
    <>
      <Alert
        severity='warning'
        action={
          <Button color='primary' variant='outlined' onClick={handleCloseAlert} aria-label='entendi'>
            Entendi
          </Button>
        }
      >
        <AlertTitle>
          <b>Atenção: A plataforma Alumy será descontinuada</b>
        </AlertTitle>
        <Typography variant='body1'>
          A plataforma Alumy será descontinuada. Você tem até o dia 31/03 para solicitar a migração do seu clube. Entre em contato{' '}
          <Link to='/producer/help'>pelo chat</Link> ou com o seu gerente de contas para saber mais e garantir a transição.
        </Typography>
      </Alert>
      <div className='m16' />
    </>
  );
};

export default AlumyWarning;
